import React, { useEffect, useState } from "react";
import { DropDown } from '@solsys/solsys-reactjs';
import { gql, useQuery } from "@apollo/client";

const gqlQuery = gql`
  query ticket_statusDropDown($ticket_status_list_request: ticket_status_list_request) {
    ticket_status(ticket_status_list_request: $ticket_status_list_request) {
      edges {
        id
        name
      }
      totalCount
    }
  }
`;

const TicketStatusDropDown = ({ selected, ...props }) => {
  const [selectedId, setSelectedId] = useState(selected);

  useEffect(() => {
    setSelectedId(selected);
  }, [selected]);

  const { data, loading, error } = useQuery(gqlQuery, {
    variables: {
      ticket_status_list_request: {
        pagination: { limit: 100, offset: 0 },
        sorting: [{ direction: "ASC", field: "id" }],
      },
    },
  });

  const items = data?.ticket_status?.edges ?? [];
  const selectedItem = items.find(
    (opt) => Number(opt.id) === Number(selectedId)
  );

  if (error) {
    console.error(`Ticket status drop down data error : ${error.message}`);
  }

  return (
    <DropDown
      items={ items }
      loading={ loading }
      renderLoading={ loading }
      multiple={ false }
      searchEnabled={ false }
      searchValue=""
      onSearch={ () => { } }
      createEnabled={ false }
      createNew={ () => { } }
      selectValue={ selectedId }
      selectRender={ selectedItem ? [selectedItem] : [] }
      dataKey="id"
      textKey="name"
      truncateLength={ 25 }
      paginationInfo={ { currentPage: 1, totalPages: 1 } }
      entityCount={ data?.ticket_status?.totalCount ?? items.length }
      onPaginationChange={ () => { } }
      { ...props }
    />
  );
};

export default TicketStatusDropDown;
